import Icon from '../../components/Icon.vue'

Icon.register({"regular/window-minimize":{"width":512,"height":512,"paths":[{"d":"M480 480H32C14.3 480 0 465.7 0 448S14.3 416 32 416H480C497.7 416 512 430.3 512 448S497.7 480 480 480z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/window-minimize.js
// module id = null
// module chunks = 